export default __webpack_public_path__ + "6e50a457fa4fcc81f3e7a4f7c036b2f5.mtl";